/* eslint-disable jsx-a11y/anchor-is-valid */
import { getConfig } from '../../../_metronic/helpers/LanguageHelper'
import axios from 'axios'
import * as authHelper from '../../modules/auth/core/AuthHelpers'
import {
  ChartsWidget1Dto,
  ChartsWidgetLineDto,
  CardsWidget17Dto,
  TablesWidget5Dto,
  TablesWidget5ItemDto,
  ListsWidget6Dto,
  WordCloudDto,
  TablesWidget14Dto,
  TablesWidget14ItemDto,
} from '../../../_metronic/partials/widgets'
import { getMonthName } from '../../../_metronic/helpers/utility'
import { toast } from 'react-toastify'
import { LanguageHelp } from '../../../_metronic/helpers/LanguageHelper'
import { CardsWidget18Dto, CardsWidget18Dto_CompetitorVolume } from '../../../_metronic/partials/widgets/_new/cards/CardsWidget18'
const API_URL = process.env.REACT_APP_API_URL
const API_FILE_URL = process.env.REACT_APP_API_URL?.substring(0, process.env.REACT_APP_API_URL.length - 4)

export function GetCompetitorNames(): Promise<any | undefined> {
  return axios
    .get(`${API_URL}/Dashboard/GetCompetitorNameList`)
    .then((response) => {
      if (response.data.httpStatusCode === 200) {
        return response.data.result.data;
      } else {
        return []
      }
    })
    .then((response: [any]) => response.map(function (item) { return item === null ? LanguageHelp('We') : item; }))
}
export function GetReviewSubjectsForSelect2(): Promise<any | undefined> {
  return axios
    .get(`${API_URL}/Dashboard/GetReviewSubjectBasicsList`)
    .then((response) => {
      if (response.data.httpStatusCode === 200) {
        return response.data.result.data;
      } else {
        return []
      }
    })
    .then((response: [any]) => response.map(function (item) { return { label: item.name, value: item.id }; }))
}
export function GetReviewSubjects(): Promise<any | undefined> {
  return axios
    .get(`${API_URL}/Dashboard/GetReviewSubjectBasicsList`)
    .then((response) => {
      if (response.data.httpStatusCode === 200) {
        return response.data.result.data;
      } else {
        return []
      }
    })
    .then((response: [any]) => response.map(function (item) { return item.name; }))
}

export function GetReviewChannels(): Promise<any | undefined> {
  return axios
    .get(`${API_URL}/Dashboard/GetReviewChannelBasicsList`)
    .then((response) => {
      if (response.data.httpStatusCode === 200) {
        return response.data.result.data;
      } else {
        return []
      }
    })
    .then((response: [any]) => response.map(function (item) { return { key: item.id, value: item.label, type: item.channelType }; }))
}

// Server should return AuthModel
export function GetCompetitionVolumeDistribution(date = "") {
  const auth = authHelper.getAuth()
  // console.log('auth', auth)
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetVolumeDistribution`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
    params: {
      'date': date
    }
  }).then(response => {
    var responseParsed: CardsWidget18Dto = {
      allCount: response.data.result.data.totalCount as number,
      competitorVolumes: []
    };
    response.data.result.data.competitorVolumeList.forEach((element: any) => {
      if (element !== undefined) {
        var competitorVolumeParsed: CardsWidget18Dto_CompetitorVolume = {
          competitorName: element.competitorName as string,
          count: element.count as number,
        }
        responseParsed.competitorVolumes.push(competitorVolumeParsed)
      }
    });
    return responseParsed;
  });
}

// Server should return AuthModel
export function GetSentimentDistribution(date = "", isYou = true) {
  const auth = authHelper.getAuth()
  // console.log('auth', auth)
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetSentimentDistribution`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
    params: {
      'date': date,
      'isYou': isYou
    }
  }).then(response => {
    var responseParsed: CardsWidget17Dto = {
      firstCount: response.data.result.positiveCount as number,
      secondCount: response.data.result.negativeCount as number,
      thirdCount: response.data.result.neutralCount as number,
      firstRate: response.data.result.positiveRate as number,
      secondRate: response.data.result.negativeRate as number,
      thirdRate: response.data.result.neutralRate as number,
      allCount: response.data.result.sentimentCount as number,
      rate: response.data.result.increaseRate as number
    };
    return responseParsed;
  });
}

export function DownloadTestSentimentRateByChannels() {
  const auth = authHelper.getAuth()

  const toastId = toast.loading(LanguageHelp('Your download process has been started!'));
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/DownloadTestSentimentRateByChannels`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
  }).then(response => {
    if (response.data.httpStatusCode === 200) {
      toast.update(toastId, { render: LanguageHelp('File downloaded successfully!'), type: "success", isLoading: false, autoClose: 3000 });
      window.location.href = API_FILE_URL + response.data.result;
    } else {
      toast.update(toastId, { render: response.data.message === null ? LanguageHelp('An unexpected error has occurred') : LanguageHelp(response.data.message), type: "error", isLoading: false, autoClose: 3000 });
    }
    return response.data.result;
  });
}

export function GetTestSentimentRateByChannels(date = "", subject = "", channelType = "", competitorName = "") {
  const auth = authHelper.getAuth()
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetTestSentimentRateByChannels`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
    params: {
      'date': date,
      'subject': subject != null ? subject.replaceAll("asc38", "&") : null,
      'channelType': channelType,
      'competitorName': competitorName,
    }
  }).then(response => {
    var responseParsedList = new TablesWidget5Dto
    responseParsedList.items.shift()
    responseParsedList.totalCount = response.data.result.totalCount
    responseParsedList.totalRate = response.data.result.totalRate
    response.data.result.reviewDocumentSentimentChannelCountItemDto.forEach((element: any) => {
      if (element !== undefined) {
        var responseParsed: TablesWidget5ItemDto = {
          label: element.channelName as string,
          type: element.channelType as number,
          isCompetitor: element.isCompetitor as boolean,
          firstCount: element.totalCount as number,
          secondCount: element.positiveCount as number,
          thirdCount: element.negativeCount as number,
          fourthCount: element.neutralCount as number,
          firstRate: element.totalRate as number,
          secondRate: element.positiveRate as number,
          thirdRate: element.negativeRate as number,
          fourthRate: element.neutralRate as number,
          image: "",
          url: "/apps/artificial-intelligence/overview?filter_channel=" + element.id
        }
        if (responseParsed.type == 2) {
          responseParsed.image = "/media/svg/brand-logos/twitter.svg"
        }
        else if (responseParsed.type == 4) {
          responseParsed.image = "/media/svg/brand-logos/facebook-3.svg"
          responseParsed.label = responseParsed.label.replace("Facebook", "")
          responseParsed.label = responseParsed.label.replace("facebook", "")
        }
        else if (responseParsed.type == 5) {
          responseParsed.image = "/media/svg/brand-logos/eksisozluk.svg"
        }
        else if (responseParsed.type == 3) {
          responseParsed.image = "/media/svg/brand-logos/sikayetvar.png"
        }
        else if (responseParsed.type === 7) {
          responseParsed.image = "/media/svg/brand-logos/instagram-2-1.svg"
        }
        else if (responseParsed.type === 8) {
          responseParsed.image = "/media/svg/brand-logos/youtube.svg"
        }
        else if (responseParsed.type === 9) {
          responseParsed.image = "/media/svg/brand-logos/reddit.svg"
        }
        else if (responseParsed.type === 10) {
          responseParsed.image = "/media/svg/brand-logos/instagram-comments.png"
        }
        else if (responseParsed.type === 11) {
          responseParsed.image = "/media/svg/brand-logos/tiktok-sharing.png"
        }
        else if (responseParsed.type === 12) {
          responseParsed.image = "/media/svg/brand-logos/tiktok-comments.png"
        }
        else
          responseParsed.image = "/media/svg/general/api-cloud.svg"

        responseParsedList.items.push(responseParsed)
      }
    });
    return responseParsedList
  });
}

export function GetTestSentimentCountByCompetitors(date = "", subject = "") {
  const auth = authHelper.getAuth()
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetTestCountBySentimentAndCompetitor`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
    params: {
      'date': date,
      'subject': subject != null ? subject.replaceAll("asc38", "&") : null,
    }
  }).then(response => {
    var responseParsedList = [new ChartsWidget1Dto]
    responseParsedList[0].label = "-";

    if (response.data.result.length !== 0) {
      responseParsedList.shift();
      response.data.result.forEach((element: any) => {
        if (element !== undefined) {
          var responseParsed: ChartsWidget1Dto = {
            label: element.competitor as string,
            subject: '',
            firstCount: element.positiveCount as number,
            secondCount: element.negativeCount as number,
            thirdCount: element.neutralCount as number,
          }
          responseParsedList.push(responseParsed)
        }
      });
    }
    return responseParsedList
  });
}

export function DownloadTestCountBySentimentAndCompetitor() {
  const auth = authHelper.getAuth()

  const toastId = toast.loading(LanguageHelp('Your download process has been started!'));
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/DownloadTestCountBySentimentAndCompetitor`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
  }).then(response => {
    if (response.data.httpStatusCode === 200) {
      toast.update(toastId, { render: LanguageHelp('File downloaded successfully!'), type: "success", isLoading: false, autoClose: 3000 });
      window.location.href = API_FILE_URL + response.data.result;
    } else {
      toast.update(toastId, { render: response.data.message === null ? LanguageHelp('An unexpected error has occurred') : LanguageHelp(response.data.message), type: "error", isLoading: false, autoClose: 3000 });
    }
    return response.data.result;
  });
}

export function GetTestSentimentCountByPlatforms(date = "", competitor = "") {
  const auth = authHelper.getAuth()
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetTestCountBySentimentAndPlatform`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
    params: {
      'date': date,
      'competitor': competitor != null ? competitor.replaceAll("asc38", "&") : null,
    }
  }).then(response => {
    var responseParsedList = [new ChartsWidget1Dto]
    responseParsedList[0].label = "-";

    if (response.data.result.length !== 0) {
      responseParsedList.shift();
      response.data.result.forEach((element: any) => {
        if (element !== undefined) {
          var responseParsed: ChartsWidget1Dto = {
            label: LanguageHelp(element.platform),
            subject: '',
            firstCount: element.positiveCount as number,
            secondCount: element.negativeCount as number,
            thirdCount: element.neutralCount as number,
          }
          responseParsedList.push(responseParsed)
        }
      });
    }
    return responseParsedList
  });
}

export function DownloadTestCountBySentimentAndPlatform() {
  const auth = authHelper.getAuth()

  const toastId = toast.loading(LanguageHelp('Your download process has been started!'));
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/DownloadTestCountBySentimentAndPlatform`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
  }).then(response => {
    if (response.data.httpStatusCode === 200) {
      toast.update(toastId, { render: LanguageHelp('File downloaded successfully!'), type: "success", isLoading: false, autoClose: 3000 });
      window.location.href = API_FILE_URL + response.data.result;
    } else {
      toast.update(toastId, { render: response.data.message === null ? LanguageHelp('An unexpected error has occurred') : LanguageHelp(response.data.message), type: "error", isLoading: false, autoClose: 3000 });
    }
    return response.data.result;
  });
}

export function GetTestSentimentCountByCompetitorsAndSubjects(date = "", subject = "") {
  const auth = authHelper.getAuth()
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetTestCountBySentimentAndCompetitorAndSubject`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
    params: {
      'date': date,
      'subject': subject != null ? subject.replaceAll("asc38", "&") : null,
    }
  }).then(response => {
    var responseParsedList = [new ChartsWidget1Dto]
    responseParsedList[0].label = "-";

    if (response.data.result !== null && response.data.result.length !== 0) {
      responseParsedList.shift();
      response.data.result.forEach((element: any) => {
        if (element !== undefined) {
          var responseParsed: ChartsWidget1Dto = {
            label: element.competitor as string,
            subject: element.subject as string,
            firstCount: element.positiveCount as number,
            secondCount: element.negativeCount as number,
            thirdCount: element.neutralCount as number,
          }
          responseParsedList.push(responseParsed)
        }
      });
    }
    return responseParsedList
  });
}

export function DownloadTestCountBySentimentAndCompetitorAndSubject() {
  const auth = authHelper.getAuth()

  const toastId = toast.loading(LanguageHelp('Your download process has been started!'));
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/DownloadTestCountBySentimentAndCompetitorAndSubject`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
  }).then(response => {
    if (response.data.httpStatusCode === 200) {
      toast.update(toastId, { render: LanguageHelp('File downloaded successfully!'), type: "success", isLoading: false, autoClose: 3000 });
      window.location.href = API_FILE_URL + response.data.result;
    } else {
      toast.update(toastId, { render: response.data.message === null ? LanguageHelp('An unexpected error has occurred') : LanguageHelp(response.data.message), type: "error", isLoading: false, autoClose: 3000 });
    }
    return response.data.result;
  });
}

export function GetTestSentimentCountByMonths(subject = "") {
  const auth = authHelper.getAuth()
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetTestCountBySentimentAndMonth`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
    params: {
      'subject': subject != null ? subject.replaceAll("asc38", "&") : null,
    }
  }).then(response => {
    var responseParsedList = [new ChartsWidget1Dto]
    responseParsedList[0].label = "-";

    if (response.data.result.length !== 0) {
      responseParsedList.shift();
      response.data.result.forEach((element: any) => {
        if (element !== undefined) {
          var responseParsed: ChartsWidget1Dto = {
            label: getMonthName(element.month as number),
            subject: '',
            firstCount: element.positiveCount as number,
            secondCount: element.negativeCount as number,
            thirdCount: element.neutralCount as number,
          }
          responseParsedList.push(responseParsed)
        }
      });
    }
    return responseParsedList
  });
}

export function DownloadTestCountBySentimentAndMonth() {
  const auth = authHelper.getAuth()

  const toastId = toast.loading(LanguageHelp('Your download process has been started!'));
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/DownloadTestCountBySentimentAndMonth`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
  }).then(response => {
    if (response.data.httpStatusCode === 200) {
      toast.update(toastId, { render: LanguageHelp('File downloaded successfully!'), type: "success", isLoading: false, autoClose: 3000 });
      window.location.href = API_FILE_URL + response.data.result;
    } else {
      toast.update(toastId, { render: response.data.message === null ? LanguageHelp('An unexpected error has occurred') : LanguageHelp(response.data.message), type: "error", isLoading: false, autoClose: 3000 });
    }
    return response.data.result;
  });
}

export function GetTestSentimentCountByDays(subject = "") {
  const auth = authHelper.getAuth()
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetTestCountBySentimentAndDay`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
    params: {
      'subject': subject != null ? subject.replaceAll("asc38", "&") : null,
    }
  }).then(response => {
    var responseParsedList = [new ChartsWidgetLineDto]
    responseParsedList[0].label = 0;

    if (response.data.result.length !== 0) {
      responseParsedList.shift();
      response.data.result.forEach((element: any) => {
        if (element !== undefined) {
          var responseParsed: ChartsWidgetLineDto = {
            label: element.day,
            firstCount: element.positiveCount as number,
            secondCount: element.negativeCount as number,
            thirdCount: element.neutralCount as number,
          }
          responseParsedList.push(responseParsed)
        }
      });
    }
    return responseParsedList
  });
}

export function DownloadTestCountBySentimentAndDay() {
  const auth = authHelper.getAuth()

  const toastId = toast.loading(LanguageHelp('Your download process has been started!'));
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/DownloadTestCountBySentimentAndDay`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
  }).then(response => {
    if (response.data.httpStatusCode === 200) {
      toast.update(toastId, { render: LanguageHelp('File downloaded successfully!'), type: "success", isLoading: false, autoClose: 3000 });
      window.location.href = API_FILE_URL + response.data.result;
    } else {
      toast.update(toastId, { render: response.data.message === null ? LanguageHelp('An unexpected error has occurred') : LanguageHelp(response.data.message), type: "error", isLoading: false, autoClose: 3000 });
    }
    return response.data.result;
  });
}

export function GetNotifications() {
  const auth = authHelper.getAuth()
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetNotificationListForAgent`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    }
  }).then(response => {
    var responseParsedList = [new ListsWidget6Dto]
    responseParsedList.shift();
    response.data.result.forEach((element: any) => {
      if (element !== undefined) {
        var responseParsed: ListsWidget6Dto = {
          label: element.notificationText,
          url: element.notificationUrl,
          className: element.notificationColor === "1" ? "d-flex align-items-center bg-light-danger rounded p-4 mb-3" : (element.notificationColor === "2" ? "d-flex align-items-center bg-light-warning rounded p-4 mb-3" : "d-flex align-items-center bg-light-success rounded p-4 mb-3"),
        }
        responseParsedList.push(responseParsed)
      }
    });
    return responseParsedList
  });
}

export function GetTokenListForWordCloudList(date = "") {
  return axios({
    method: 'post',
    url: `${API_URL}/dashboard/GetTokenListForWordCloud`,
    data: {
      'size': 50,
      'date': date,
    }
  }).then(response => {
    var responseParsedList = [new WordCloudDto]
    responseParsedList[0].text = "-";

    if (response.data.result.data !== null) {
      responseParsedList.shift();
      response.data.result.data.forEach((element: any) => {
        if (element !== undefined) {
          var responseParsed: WordCloudDto = {
            text: element.text,
            value: element.totalCount,
            positiveCount: element.positiveCount,
            negativeCount: element.negativeCount,
            neutralCount: element.neutralCount,
            sentimentRate: element.sentimentRate,
          }
          responseParsedList?.push(responseParsed)
        }
      });
    }

    return responseParsedList
  });
}

export function GetTokenForTableList(date = "") {
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetTokenCountList`,
    params: {
      'date': date
    }
  }).then(response => {
    var responseParsedList = new TablesWidget14Dto
    responseParsedList.items[0].label = "-";

    if (response.data.result.tokenCountItemDtoList !== null
      && response.data.result.tokenCountItemDtoList.length !== 0) {
      responseParsedList.items.shift()
      responseParsedList.totalCount = response.data.result.totalCount
      responseParsedList.totalRate = response.data.result.totalRate
      response.data.result.tokenCountItemDtoList.forEach((element: any) => {
        if (element !== undefined) {
          var responseParsed: TablesWidget14ItemDto = {
            label: element.tokenText as string,
            firstCount: element.totalCount as number,
            secondCount: element.positiveCount as number,
            thirdCount: element.negativeCount as number,
            fourthCount: element.neutralCount as number,
            firstRate: element.totalRate as number,
            secondRate: element.positiveRate as number,
            thirdRate: element.negativeRate as number,
            fourthRate: element.neutralRate as number,
          }
          responseParsedList.items.push(responseParsed)
        }
      });
    }
    return responseParsedList
  });
}

export function DownloadTokensForTable() {
  const auth = authHelper.getAuth()

  const toastId = toast.loading(LanguageHelp('Your download process has been started!'));
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/DownloadTokenList`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
  }).then(response => {
    if (response.data.httpStatusCode === 200) {
      toast.update(toastId, { render: LanguageHelp('File downloaded successfully!'), type: "success", isLoading: false, autoClose: 3000 });
      window.location.href = API_FILE_URL + response.data.result;
    } else {
      toast.update(toastId, { render: response.data.message === null ? LanguageHelp('An unexpected error has occurred') : LanguageHelp(response.data.message), type: "error", isLoading: false, autoClose: 3000 });
    }
    return response.data.result;
  });
}

export function GetSubjectSentimentListForWordCloudList(date = "") {
  return axios({
    method: 'post',
    url: `${API_URL}/dashboard/GetSubjectSentimentListForWordCloud`,
    data: {
      'size': 50,
      'date': date,
    }
  }).then(response => {
    var responseParsedList = [new WordCloudDto]
    responseParsedList[0].text = "-";

    if (response.data.result.data !== null) {
      responseParsedList.shift();
      response.data.result.data.forEach((element: any) => {
        if (element !== undefined) {
          var responseParsed: WordCloudDto = {
            text: element.text,
            value: element.totalCount,
            positiveCount: element.positiveCount,
            negativeCount: element.negativeCount,
            neutralCount: element.neutralCount,
            sentimentRate: element.sentimentRate,
          }
          responseParsedList?.push(responseParsed)
        }
      });
    }

    return responseParsedList
  });
}

export function GetSubjectSentimentForTableList(date = "") {
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetSubjectSentimentCountList`,
    params: {
      'date': date
    }
  }).then(response => {
    var responseParsedList = new TablesWidget14Dto
    responseParsedList.items[0].label = "-";

    if (response.data.result.reviewDocumentSentimentChannelCountItemDtoList !== null
      && response.data.result.reviewDocumentSentimentChannelCountItemDtoList.length !== 0) {
      responseParsedList.items.shift()
      responseParsedList.totalCount = response.data.result.totalCount
      responseParsedList.totalRate = response.data.result.totalRate
      response.data.result.reviewDocumentSentimentChannelCountItemDtoList.forEach((element: any) => {
        if (element !== undefined) {
          var responseParsed: TablesWidget14ItemDto = {
            label: element.subject as string,
            firstCount: element.totalCount as number,
            secondCount: element.positiveCount as number,
            thirdCount: element.negativeCount as number,
            fourthCount: element.neutralCount as number,
            firstRate: element.totalRate as number,
            secondRate: element.positiveRate as number,
            thirdRate: element.negativeRate as number,
            fourthRate: element.neutralRate as number,
          }
          responseParsedList.items.push(responseParsed)
        }
      });
    }
    return responseParsedList
  });
}

export function DownloadSubjectSentimentsForTable() {
  const auth = authHelper.getAuth()

  const toastId = toast.loading(LanguageHelp('Your download process has been started!'));
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/DownloadSubjectSentimentList`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
  }).then(response => {
    if (response.data.httpStatusCode === 200) {
      toast.update(toastId, { render: LanguageHelp('File downloaded successfully!'), type: "success", isLoading: false, autoClose: 3000 });
      window.location.href = API_FILE_URL + response.data.result;
    } else {
      toast.update(toastId, { render: response.data.message === null ? LanguageHelp('An unexpected error has occurred') : LanguageHelp(response.data.message), type: "error", isLoading: false, autoClose: 3000 });
    }
    return response.data.result;
  });
}

export function GetAutoClassSentimentListForWordCloudList(date = "") {
  return axios({
    method: 'post',
    url: `${API_URL}/dashboard/GetAutoClassSentimentListForWordCloud`,
    data: {
      'size': 50,
      'date': date,
    }
  }).then(response => {
    var responseParsedList = [new WordCloudDto]
    responseParsedList[0].text = "-";

    if (response.data.result.data !== null) {
      responseParsedList.shift();
      response.data.result.data.forEach((element: any) => {
        if (element !== undefined) {
          var responseParsed: WordCloudDto = {
            text: element.text,
            value: element.totalCount,
            positiveCount: element.positiveCount,
            negativeCount: element.negativeCount,
            neutralCount: element.neutralCount,
            sentimentRate: element.sentimentRate,
          }
          responseParsedList?.push(responseParsed)
        }
      });
    }

    return responseParsedList
  });
}

export function GetAutoClassSentimentForTableList(date = "") {
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/GetAutoClassSentimentCountList`,
    params: {
      'date': date
    }
  }).then(response => {
    var responseParsedList = new TablesWidget14Dto
    responseParsedList.items[0].label = "-";

    if (response.data.result.reviewDocumentSentimentChannelCountItemDtoList !== null
      && response.data.result.reviewDocumentSentimentChannelCountItemDtoList.length !== 0) {
      responseParsedList.items.shift()
      responseParsedList.totalCount = response.data.result.totalCount
      responseParsedList.totalRate = response.data.result.totalRate
      response.data.result.reviewDocumentSentimentChannelCountItemDtoList.forEach((element: any) => {
        if (element !== undefined) {
          var responseParsed: TablesWidget14ItemDto = {
            label: element.autoClass as string,
            firstCount: element.totalCount as number,
            secondCount: element.positiveCount as number,
            thirdCount: element.negativeCount as number,
            fourthCount: element.neutralCount as number,
            firstRate: element.totalRate as number,
            secondRate: element.positiveRate as number,
            thirdRate: element.negativeRate as number,
            fourthRate: element.neutralRate as number,
          }
          responseParsedList.items.push(responseParsed)
        }
      });
    }
    return responseParsedList
  });
}

export function DownloadAutoClassSentimentsForTable() {
  const auth = authHelper.getAuth()

  const toastId = toast.loading(LanguageHelp('Your download process has been started!'));
  return axios({
    method: 'get',
    url: `${API_URL}/dashboard/DownloadAutoClassSentimentList`,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
  }).then(response => {
    if (response.data.httpStatusCode === 200) {
      toast.update(toastId, { render: LanguageHelp('File downloaded successfully!'), type: "success", isLoading: false, autoClose: 3000 });
      window.location.href = API_FILE_URL + response.data.result;
    } else {
      toast.update(toastId, { render: response.data.message === null ? LanguageHelp('An unexpected error has occurred') : LanguageHelp(response.data.message), type: "error", isLoading: false, autoClose: 3000 });
    }
    return response.data.result;
  });
}